import { configureStore } from '@reduxjs/toolkit';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { loggerMiddleware } from './loggerMiddleware';
import rental, { rentalApi } from '../../shared/redux/rental';
import version, { versionApi } from '../../shared/redux/version';
import tbn, { tbnApi } from './tbn';
import leftFilterState from './leftFilterState';
import viewSetting from './viewSetting';
import rentalOrderState from '../../shared/redux/local/rentalOrderState';

// Put additional reducers here
export const store = configureStore({
  reducer: {
    leftFilterState,
    rentalOrderState,
    rental,
    version,
    viewSetting,
    tbn,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  })
    .concat(rentalApi.middleware, versionApi.middleware, tbnApi.middleware)
    .concat(loggerMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch
